<template>
  <div class="info-icon">
    <button v-if="content" :data-qa="dataQa" @click.prevent="showModal = true">
      <icon icon="info-plain" large />
    </button>
    <modal v-if="showModal" :title="title" @close="showModal = false">
      <div v-html="content"></div>
    </modal>
  </div>
</template>
<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
export default {
  components: {
    Icon,
    Modal,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      required: true,
    },
    dataQa: {
      type: String,
      default: null,
    },
  },
  data() {
    return { showModal: false }
  },
}
</script>
<style lang="scss" scoped>
.info-icon {
  display: inline-block;
}
</style>
